var _defs, _use;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcTeams(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M40.37 525.379c0 1.427-1.1 2.579-2.462 2.579s-2.462-1.152-2.462-2.58c0-1.426 1.1-2.578 2.462-2.578s2.461 1.152 2.461 2.579zm-7.385 6.408c0-1.72 3.282-2.665 4.923-2.665 1.64 0 4.923.945 4.923 2.665v.86h-9.846v-.86zm19.2-6.408c0 1.427-1.1 2.579-2.462 2.579s-2.461-1.152-2.461-2.58c0-1.426 1.099-2.578 2.461-2.578 1.362 0 2.462 1.152 2.462 2.579zm-7.385 6.408c0-1.72 3.282-2.665 4.923-2.665s4.923.945 4.923 2.665v.86H44.8v-.86zm1.477-19.208c0 1.427-1.1 2.579-2.462 2.579s-2.461-1.152-2.461-2.58c0-1.426 1.1-2.578 2.461-2.578 1.362 0 2.462 1.152 2.462 2.579zm-7.385 6.408c0-1.72 3.282-2.665 4.923-2.665s4.923.945 4.923 2.665v.86h-9.846v-.86z"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    fillRule: "evenodd",
    transform: "translate(-32 -510)",
    xlinkHref: "#a"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTeams);
export default __webpack_public_path__ + "static/media/ic-teams.89514b1927ff569b810d40f6ac35e383.svg";
export { ForwardRef as ReactComponent };